module.exports = __webpack_public_path__ + "static/img/product-epidemic.c5a50a00.png";